import React, { useCallback, useContext, useEffect, useState } from 'react'
import { BsTrophy } from 'react-icons/bs';
import Button from "../../components/EmptyButton";
import { FaBookOpen, FaUsers } from 'react-icons/fa';
import heroImage from '../../assets/images/hero-students.jpg'
import Select from '../Select';
import { useDispatch, useSelector } from 'react-redux';
import { createErrorAlert, getSiteSearch } from '../../redux/actions';
import { useHistory } from 'react-router-dom';
import search_icon from "../../assets/images/search.webp";
import convertSlugToText from '../../helpers/slugToText';
import { debounce } from "lodash";
import { getApiKey } from '../../helpers';
import Context from '../../services/Context.js';



const HeroSection = () => {

  const siteSearchData = useSelector(
    ({ store }) => store.siteSearchReducer.data
  );
  const loading = useSelector(({ store }) => store.siteSearchReducer.loading);

  const dispatch = useDispatch()
  const history = useHistory()
  const [module, setModule] = useState([]);
  const [searchChange, setSearchChange] = useState("Type to Search");
  const { value, updateValue } = useContext(Context);

  const handleAiTutorClick = () => {
    if (getApiKey()) {
      history.push('/aitutor');
    } else {
      updateValue({ ...value, requestLoginModal: true, loginRedirectTo: "/aitutor" });
    }
  };



  useEffect(() => {
    if (siteSearchData) {
      if (siteSearchData.length > 0) {
        let modules = [];
        siteSearchData.map((item) => {
          if (item?.title?.includes("summary")) {
            return null;
          } else {
            modules.push({
              value: item,
              label: `${convertSlugToText(item.title)}  -  ${item.type}`,
            });
          }
        });
        setModule(modules);
      }
    }
  }, [siteSearchData])
  const handleSelectChange = (change) => {
    if (change.length === 0) {
      setSearchChange("Type to Search");
      return;
    }

    setSearchChange(
      "We cannot find what you are looking for. You can search by case names or legal principles e.g., consideration"
    );

    debouncedSearch(change);
  };

  const debouncedSearch = useCallback(
    debounce((change) => {
      dispatch(getSiteSearch(change));
    }, 300),
    []
  );

  const handleSelectedModule = (selected) => {
    if (selected.value.type === "Note") {
      localStorage.setItem("studyModule", selected?.value?.study_module?.slug);
      if (selected.value.type === "Note") {
        history.push({
          pathname: `/${selected?.value?.study_module?.slug}/notes/${selected.value.slug}`,
          state: { selected },
        });
        window.location.replace(
          `/${selected?.value?.study_module?.slug}/notes/${selected.value.slug}`
        );
      }
    } else {
      localStorage.setItem("studyModule", selected?.value?.study_module?.slug);
      if (selected.value.type === "StudyModule") {
        history.push({
          pathname: `/study-module/${selected.value.slug}`,
          state: { selected },
        });
      } else if (selected.value.type === "Essay") {
        dispatch(
          createErrorAlert(
            211,
            "Info",
            "To view Model Essays please Login. No SimpleStudy account? Sign Up",
            211
          )
        );
      } else if (selected.value.type === "CaseStudy") {
        history.push({
          pathname: `/${selected.value.slug}/`,
          state: { selected },
        });
        window.location.replace(`/${selected.value.slug}/`);
      } else if (selected.value.type === "TutorialVideo") {
        dispatch(
          createErrorAlert(
            211,
            "Info",
            "To view Tutorial Videos please Login. No SimpleStudy account? Sign Up",
            211
          )
        );
      } else if (selected.value.type === "Quiz") {
        dispatch(createErrorAlert(211, "", "To view Quiz please Login", 211));
      } else if (selected.value.type === "FlashCard") {
        dispatch(
          createErrorAlert(
            200,
            "Info",
            `To view Flash Cards you must be logged in. No SimpleStudy account?`,
            200
          )
        );
      } else if (selected.value.type === "Blog") {
        history.push({
          pathname: `/blogs/${selected.value.slug}/`,
          state: { selected },
        });
        window.location.replace(`/blogs/${selected.value.slug}/`);
      }
    }
  };

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-secondary via-background to-secondary/50 mt-48 sm:mt-56 xs:mt-64">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <h1 className="text-4xl lg:text-6xl font-bold text-foreground leading-tight">
                <span className="text-primary" style={{ fontSize: '3rem', fontWeight: '700' }}>Everything you need to</span>
                <span className="block text-foreground" style={{ fontSize: '3rem', fontWeight: '700' }}>Succeed in university and beyond</span>
              </h1>
              <p style={{ color: '#78726d' }} className="text-xl text-muted-foreground leading-relaxed">
                StudyCrowd.AI helps US and UK university students get high grades and build successful careers with simple study materials, personalized tutoring and career mentoring.
              </p>
            </div>


            <div className="relative w-full">
              <Select
                placeholder="Search for courses and study materials"
                values={module}
                id="topSearch"
                handleSelected={handleSelectedModule}
                valueChange={handleSelectChange}
                noOptionMessage={
                  <div className="relative overflow-hidden">
                    {searchChange}
                    <div
                      className="bg-primary text-white text-center py-2 mt-2 rounded-xl w-full cursor-pointer"
                      onClick={handleAiTutorClick}
                    >
                      <p>ASK THE AI TUTOR INSTEAD</p>
                    </div>
                  </div>
                }
                loading={loading}
                className="w-full h-12 pl-12 pr-4 border-2 border-[#D58C5A] rounded-full text-gray-600 placeholder-gray-500"
              />

              {/* search icon - no border */}
              <div className="absolute right-8 top-4 bg-white -translate-y-2">
                <img src={search_icon} alt="search_icon" width="18" />
              </div>
            </div>


            <div className="flex items-center space-x-3 p-4 bg-card rounded-lg shadow-card border" style={{ borderColor: 'lightgray' }}>
              <BsTrophy className="w-6 h-6 text-primary" />
              <p className="text-foreground" style={{ fontWeight: '500' }}>
                Find simple study resources created by top students and graduates studying the same degree as you.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                filled={true}
                text={'Start Learning Today'}
                className={"text-lg px-8 py-2"}
                onClick={() => window.open('https://studycrowd.ai/login', '_blank')}
              />
              <Button
                className="text-lg px-8 py-2"
                onClick={() => {
                  const servicesSection = document.querySelector('#services-section');
                  servicesSection?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Learn More
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 pt-8">
              <div className="text-center">
                <div className="text-primary" style={{ fontSize: '1.875rem', fontWeight: '700' }}>50K+</div>
                <div className="text-sm text-muted-foreground" style={{ color: '#78726d' }}>Active Users</div>
              </div>
              <div className="text-center">
                <div className="text-primary" style={{ fontSize: '1.875rem', fontWeight: '700' }}>2000+</div>
                <div className="text-sm text-muted-foreground" style={{ color: '#78726d' }}>Tutoring and Career Mentoring Hours Delivered</div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-floating">
              <img
                src={heroImage}
                alt="Students studying together"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent"></div>
            </div>

            {/* Floating Elements */}
            <div className="absolute bg-white -top-4 -right-4 bg-card p-4 rounded-lg shadow-elegant">
              <FaUsers className="w-8 h-8 text-primary" />
            </div>
            <div className="absolute bg-white -bottom-4 -left-4 bg-card p-4 rounded-lg shadow-elegant">
              <FaBookOpen className="w-8 h-8 text-primary" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;